<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <span v-if="asstabpreco.tabpreco && asstabpreco.tabpreco != null">
                    {{ $t('tabpreco') }}: {{ asstabpreco.tabpreco.descricao }}
                </span>
                <span v-else> {{ $t('tabpreco') }}: {{ selected.descricao }} </span>
            </div>
            <div class="header-buttons">
                <button class="save-btn" type="button" @click="save">
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AssTabPrecoCliente from '@/services/vendas/cliente/abas/AssTabPrecoClienteService';
import Message from '@/models/Message';

export default {

    props: {
        selected: {
            type: Object,
            default: () => {},
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new AssTabPrecoCliente(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            asstabpreco: {
                idtabprecocliente: null,
                idtabpreco: null,
                idcliente: null,
                tabpreco: null,
            },
            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },
    created() {
        this.asstabpreco.idcliente = this.selected.idcliente;
        this.asstabpreco.idtabpreco = this.selected.idtabpreco;
        if (this.selected.idtabprecocliente != null) {
            this.carregarDados(this.selected.idtabprecocliente);
        }
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.asstabpreco = value.content;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },

        generateId(numberId) {
            return this.$route.name + '-asstabpreco-' + numberId;
        },
        save() {
            this.isLoading = true;
            this.saveTP()
                .then((value) => {
                    if (value.content === null) {
                        this.msgs.push(new Message('error', `${value.message}`, true));
                    } else {
                        this.$root.showMessage(
                            'success',
                            this.asstabpreco.idtabprecocliente != null
                                ? 'msg-sucesso-ao-editar-associcao'
                                : 'msg-sucesso-ao-adicionar-associacao'
                        );
                        setTimeout(() => {
                            this.$emit('fecharModal', true);
                        }, 200);
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        saveTP() {
            if (this.isVenda) return this.service.saveVendas(this.asstabpreco);
            else return this.service.saveAgro(this.asstabpreco);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
}
</style>
